import { render, staticRenderFns } from "./DetailProduitsHorsMarche.vue?vue&type=template&id=445e15b6&"
import script from "./DetailProduitsHorsMarche.vue?vue&type=script&lang=js&"
export * from "./DetailProduitsHorsMarche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports